import { useMutation } from "react-query";
import { useSelector, useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { filtersActions, uiActions } from "store";
import { getCurrentUserAccessToken } from "store/user/user.reducer";
import { ErrorResponse } from "types";

type useMutationProps = {
	fetchData: {
		page: number;
		filters: { [key: string]: any };
		sortBy: { [key: string]: any };
	};
};

const useDownloadChargebackCsvFileMutation = (formName, service) => {
	const dispatch = useDispatch();

	const token = useSelector(getCurrentUserAccessToken);

	return useMutation(
		async ({ fetchData }: useMutationProps) => {
			const { page, sortBy, filters } = fetchData;
			if (!token) return Promise.reject("Token is missing");
			return service({
				page,
				filters,
				sortBy,
				token,
			});
		},
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "CSV has been downloaded successfully",
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
				dispatch(filtersActions.setIsExported(formName, false));
			},
		},
	);
};

export default useDownloadChargebackCsvFileMutation;
